import { FC } from 'react';
import React from 'react';
import FormCheckbox from '../../../base-components/Checkbox/FormCheckbox';
import { FormErrorBag } from '../../../base-components/FormErrorBag';
import { FormTextInput } from '../../../base-components/FormTextInput';
import { FormSelectOrgForm } from './components/FormSelectOrgForm';
import { FormSelectOrgType } from './components/FormSelectOrgType';
import { FormSelectRegion } from './components/FormSelectRegion';
import { useFormOrgHook } from './lib/useFormOrgHook';
import commonStyles from './Registration.module.scss';
import { RegistrationProps } from './Registration.type';
import styles from './RegistrationSecondStep.module.scss';

export const RegistrationSecondStep: FC<RegistrationProps> = ({
    orgTypes,
    orgForms,
    regions,
}) => {
    const { isFilial, isIP, isUL } = useFormOrgHook(orgForms);

    return (
        <div className={commonStyles.container}>
            <h3 className={commonStyles.sectionHeading}>
                Информация об организации
            </h3>

            <div className={commonStyles.fieldHeading}>Субъект права</div>
            <FormSelectOrgType
                name="organization.orgType"
                orgTypes={orgTypes}
                className={styles.orgType}
            />

            {(isIP || isUL) && (
                <>
                    <div className={commonStyles.fieldHeading}>
                        Организационно-правовая форма
                    </div>
                    <FormSelectOrgForm
                        name="organization.orgForm"
                        orgForms={orgForms}
                        className={styles.orgForm}
                        isDisabled={isIP}
                    />
                </>
            )}

            {(isIP || isUL) && (
                <FormTextInput
                    name="organization.fullName"
                    label="Полное наименование организации, включая ОПФ"
                    className={styles.fullName}
                    disabled={isIP}
                />
            )}

            <FormTextInput
                name="organization.inn"
                label="ИНН"
                className={styles.inn}
            />

            {isUL && (
                <FormTextInput
                    name="organization.kpp"
                    label="КПП"
                    className={styles.kpp}
                />
            )}

            {isUL && (
                <FormCheckbox
                    name="organization.isFilial"
                    className={styles.inputFilial}
                    disabled
                >
                    Организация является филиалом
                </FormCheckbox>
            )}

            {isFilial && (
                <FormTextInput
                    name="organization.headKpp"
                    label="КПП головной организации"
                    className={styles.headKpp}
                />
            )}

            <FormSelectRegion
                name="organization.region"
                regions={regions}
                className={styles.region}
            />

            <FormErrorBag name="personal" className={styles.personalBlock}>
                <FormCheckbox name="personal" className={styles.personal}>
                    Согласен на обработку персональных данных
                </FormCheckbox>
            </FormErrorBag>
        </div>
    );
};
